import React from 'react';

const Hero = () => (
  <section className="header-cover">
    <div className="hero-cover" />
    <div className="hero">
      <h3>COVID-19</h3>
      <small>Modern Day Most Strong Pandemic</small>
      <p>&quot;You can stop the spread by wearing your nose mask!!!&quot;</p>
    </div>
  </section>
);

export default Hero;
